import get from 'lodash/fp/get';

/**
 * A selector to index indicators within a geography, given a payload.
 * @param {object} state - The Redux state.
 * @param {object} payload - The payload to use for looking up indexes.
 * @returns {object} - The geography with indexes applied, if available.
 */
export default function selectIndexedIndicators(state, payload) {
  // If there are no indicators attached to this geography, return as-is.
  const indicators = get('geography.indicators')(state);
  if (!Array.isArray(indicators) || 0 === indicators.length) {
    return state && state.geography ? state.geography : {};
  }

  return {
    ...state.geography,
    indicators: indicators.map((indicator) => ({
      ...indicator,
      index: payload.bySlug[indicator.slug].index,
    })),
  };
}



// WEBPACK FOOTER //
// ./app/selectors/geography/indexedIndicators.js